module.exports = __webpack_public_path__ + "img/eye.7acb135a.svg";